import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ICalculatorState } from '../types/calculator';
import { calculate } from '../utils';

export const initialValues = {
  term: 30,
  price: 10000000,
  pskStart: 21.832,
  pskEnd: 22.979,
  mortgagePercentRate: 16.7,
  discountMortgagePercent: 4,
  discountMortgageTerm: 2,
  discountMortgagePercentBySeller: 4.1,
  bankName: 'Дом.РФ',
  logoPath: 'https://static.cdn-cian.ru/frontend/finance-assets/bages/domrf.svg',
  realEstateType: 'Вторичка',
  minPrice: 500000,
  maxPrice: 70000000,
};

export const initialState: ICalculatorState = {
  ...initialValues,
  calculatedValues: calculate(initialValues),
};

/* istanbul ignore next */
export const subsidizedCalculatorSlice = createSlice({
  initialState,
  name: 'calculator',
  reducers: {
    setFlatPrice: (state, action: PayloadAction<number>) => {
      state.price = action.payload;
      state.calculatedValues = calculate({ ...state, price: action.payload });
    },
    setCreditTerm: (state, action: PayloadAction<number>) => {
      state.term = action.payload;
      state.calculatedValues = calculate({ ...state, term: action.payload });
    },
  },
});

export const { setFlatPrice, setCreditTerm } = subsidizedCalculatorSlice.actions;
